var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c(
        "el-form",
        {
          ref: "searchForm",
          staticClass: "query-form",
          attrs: { size: "small", inline: true, model: _vm.searchForm },
          nativeOn: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.refreshList()
            },
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { prop: "nameCn" } },
            [
              _c("el-input", {
                attrs: {
                  size: "small",
                  placeholder: "中文名称",
                  clearable: "",
                },
                model: {
                  value: _vm.searchForm.nameCn,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchForm, "nameCn", $$v)
                  },
                  expression: "searchForm.nameCn",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    icon: "el-icon-search",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.refreshList()
                    },
                  },
                },
                [_vm._v("查询")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", icon: "el-icon-refresh-right" },
                  on: {
                    click: function ($event) {
                      return _vm.resetSearch()
                    },
                  },
                },
                [_vm._v("重置")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "bg-white top" },
        [
          _c("vxe-toolbar", {
            attrs: {
              refresh: { query: _vm.refreshList },
              import: "",
              export: "",
              print: "",
              custom: "",
            },
            scopedSlots: _vm._u([
              {
                key: "buttons",
                fn: function () {
                  return [
                    _vm.hasPermission(
                      "unmprojectpositionprojectitem:cecUnmProjectPositionProjectItem:del"
                    )
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "danger",
                              size: "small",
                              icon: "el-icon-delete",
                              disabled:
                                _vm.$refs
                                  .cecUnmProjectPositionProjectItemTable &&
                                _vm.$refs.cecUnmProjectPositionProjectItemTable.getCheckboxRecords()
                                  .length === 0,
                              plain: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.del()
                              },
                            },
                          },
                          [_vm._v("删除")]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "small",
                          type: "success",
                          icon: "el-icon-refresh-right",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.getCecProjectItem()
                          },
                        },
                      },
                      [_vm._v("获取CEC套餐项目材料表")]
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "tools",
                fn: function () {
                  return [
                    _vm.hasPermission(
                      "unmprojectpositionprojectitem:cecUnmProjectPositionProjectItem:import"
                    )
                      ? _c("vxe-button", {
                          staticClass: "el-icon-document m-r-12",
                          attrs: {
                            type: "default",
                            title: "下载导入模板",
                            circle: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.downloadTpl()
                            },
                          },
                        })
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _c(
            "div",
            { staticStyle: { height: "calc(100% - 80px)" } },
            [
              _c(
                "vxe-table",
                {
                  ref: "cecUnmProjectPositionProjectItemTable",
                  attrs: {
                    border: "full",
                    "auto-resize": "",
                    resizable: "",
                    height: "auto",
                    loading: _vm.loading,
                    size: "small",
                    "show-header-overflow": "",
                    "show-overflow": "",
                    "highlight-hover-row": "",
                    "menu-config": {},
                    "print-config": {},
                    "import-config": {
                      importMethod: _vm.importMethod,
                      types: ["csv", "xls", "xlsx"],
                      remote: true,
                    },
                    "export-config": {
                      remote: true,
                      filename:
                        "套餐项目材料表数据" +
                        _vm.moment(new Date()).format("YYYY-MM-DD"),
                      sheetName: "套餐项目材料表数据",
                      exportMethod: _vm.exportMethod,
                      types: ["xlsx"],
                      modes: ["current", "selected", "all"],
                    },
                    "sort-config": { remote: true },
                    data: _vm.dataList,
                    "checkbox-config": {},
                  },
                  on: { "sort-change": _vm.sortChangeHandle },
                },
                [
                  _c("vxe-column", { attrs: { type: "seq", width: "40" } }),
                  _c("vxe-column", {
                    attrs: { type: "checkbox", width: "40px" },
                  }),
                  _c("vxe-column", {
                    attrs: { field: "nameCn", sortable: "", title: "中文名称" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.hasPermission(
                              "unmprojectpositionprojectitem:cecUnmProjectPositionProjectItem:edit"
                            )
                              ? _c(
                                  "el-link",
                                  {
                                    attrs: {
                                      type: "primary",
                                      underline: false,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.edit(scope.row.id)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(scope.row.nameCn))]
                                )
                              : _vm.hasPermission(
                                  "unmprojectpositionprojectitem:cecUnmProjectPositionProjectItem:view"
                                )
                              ? _c(
                                  "el-link",
                                  {
                                    attrs: {
                                      type: "primary",
                                      underline: false,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.view(scope.row.id)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(scope.row.nameCn))]
                                )
                              : _c("span", [_vm._v(_vm._s(scope.row.nameCn))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "positionProjectId",
                      sortable: "",
                      title: "套餐项目id",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: { field: "price", sortable: "", title: "单价" },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "minUsage",
                      sortable: "",
                      title: "材料-计价最低用量",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: { field: "rateNum", sortable: "", title: "损耗率" },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "rateDesc",
                      sortable: "",
                      title: "损耗率描述",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "makeupId",
                      sortable: "",
                      title: "材料方案id",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: { field: "itemId", sortable: "", title: "材料id" },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      fixed: "right",
                      align: "center",
                      width: "200",
                      title: "操作",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.hasPermission(
                              "unmprojectpositionprojectitem:cecUnmProjectPositionProjectItem:view"
                            )
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "text",
                                      icon: "el-icon-view",
                                      size: "small",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.view(scope.row.id)
                                      },
                                    },
                                  },
                                  [_vm._v("查看")]
                                )
                              : _vm._e(),
                            _vm.hasPermission(
                              "unmprojectpositionprojectitem:cecUnmProjectPositionProjectItem:edit"
                            )
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "text",
                                      icon: "el-icon-edit",
                                      size: "small",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.edit(scope.row.id)
                                      },
                                    },
                                  },
                                  [_vm._v("修改")]
                                )
                              : _vm._e(),
                            _vm.hasPermission(
                              "unmprojectpositionprojectitem:cecUnmProjectPositionProjectItem:del"
                            )
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "text",
                                      icon: "el-icon-delete",
                                      size: "small",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.del(scope.row.id)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("vxe-pager", {
                attrs: {
                  background: "",
                  size: "small",
                  "current-page": _vm.tablePage.currentPage,
                  "page-size": _vm.tablePage.pageSize,
                  total: _vm.tablePage.total,
                  "page-sizes": [
                    10,
                    20,
                    100,
                    1000,
                    { label: "全量数据", value: 1000000 },
                  ],
                  layouts: [
                    "PrevPage",
                    "JumpNumber",
                    "NextPage",
                    "FullJump",
                    "Sizes",
                    "Total",
                  ],
                },
                on: { "page-change": _vm.currentChangeHandle },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("CecUnmProjectPositionProjectItemForm", {
        ref: "cecUnmProjectPositionProjectItemForm",
        on: { refreshDataList: _vm.refreshList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }